import React, { useEffect, useState, useRef } from "react";
import { object, bool } from "prop-types";

import FourProfileCards from "../FourProfileCards";
import { fetchEntityData } from "../../utils/entity-data";
import { fetchTrendingPeople } from "../../../../api/utils";
import { useSelector } from "react-redux";
import { get } from "lodash";

const ProfileRanking = ({ collection, storyPage = false, config, story = {} }) => {
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const trendingPeopleData = qtState?.data?.homeEntities?.TrendingPeople || {};
  const interval = trendingPeopleData?.interval || "14";
  const cdnImage = `https://${config?.["cdn-image"]}`;
  const entityData = storyPage ? collection : collection.entityData;
  const trendingPeople = !storyPage && collection?.["associated-metadata"]?.layout === "TrendingPeople";

  const [entityDetails, setEntityDetails] = useState([]);
  const [isInView, setIsInView] = useState(false);

  const { name, buttonText, buttonLink, year, showRanking, yearId, slug } = entityData || {};

  const logoName = {
    "forty-under-forty-snapshot-year": "/images/logos-square/40-under-40.png",
    "most-powerful-women-snapshot-year": "/images/logos-square/mpw-logo.png",
  };

  const ref = useRef();

  // Observe viewport entry - runs only once
  useEffect(() => {
    const observer = new window.IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsInView(true);
        observer.disconnect();
      }
    });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  // Fetch entity data only when in viewport and dependencies change
  useEffect(() => {
    if (!isInView) return; // Do not fetch until visible

    const fetchData = async () => {
      try {
        if (trendingPeople) {
          const data = await fetchTrendingPeople(`${interval}`);
          setEntityDetails(data);
        } else {
          const data = await fetchEntityData(slug, yearId);
          setEntityDetails(data);
        }
      } catch (err) {
        console.error("Failed to fetch entity details", err);
        setEntityDetails([]);
      }
    };
    fetchData();
  }, [isInView, slug, yearId, trendingPeople]);

  if (!entityDetails.length) return <div ref={ref} />;
  if (trendingPeople && entityDetails.length < 4) return <div ref={ref} style={{ marginBottom: "-50px" }} />;

  return (
    <div ref={ref}>
      <FourProfileCards
        options={entityDetails}
        heading={name}
        logoLink={logoName[entityData?.slug]}
        buttonText={buttonText}
        buttonLink={buttonLink}
        year={year}
        showRanking={showRanking}
        storyPage={storyPage}
        cdnImage={cdnImage}
        story={story}
        config={config}
        trendingPeople={trendingPeople}
      />
    </div>
  );
};

ProfileRanking.propTypes = {
  collection: object,
  storyPage: bool,
};

export default ProfileRanking;
